/* Afroyla FALL CLEARANCE — ⚡ Lightning Deals box: one product every 30 s, endless rotation over the ops list
 * (assets/afroyla-fall-clearance-rotation.json, built by afroyla-fall-clearance/build-afroyla-fall-clearance-
 * rotation-asset.mjs): [{ handle, title, type, featured_variant_id, featured_variant, price, compare_at, pct_off,
 * image }]. Rule (ops): slot = floor(Date.now()/30000) % N; if the featured (Premium Vegan) variant is sold out,
 * advance to the next available item — never a jump-scare gap. Rotation prices are fixed/display-only; live
 * availability + the full Vegan/Top-Grain pill set come from /products/<h>.js fetched on render. Only runs while
 * the page phase is 'live' (afc:phase event from afroyla-fall-clearance-access.js). Needs window.AFC. */
(function () {
  var A = window.AFC;
  if (!A) return;
  var root = A.root;
  var box = root.querySelector('[data-afc-ld]');
  var nextRow = root.querySelector('[data-afc-next-row]');
  if (!box) return;
  var ITEMS = null, N = 0;
  var SOLD = {};        // handle → false once /products/<h>.js confirms the featured variant is sold out
  var shownSlot = null;
  var cur = null;        // { it, idx, sel, vars, order }
  var started = false;

  function load() {
    fetch(root.dataset.rotation, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) { ITEMS = j; N = j.length; tick(); setInterval(tick, 250); })
      .catch(function () { box.innerHTML = '<p class="afc-ld__msg">Lightning deals are loading slowly. Please refresh the page.</p>'; });
  }

  function baseSlot() { return Math.floor(A.now() / 30000) % N; }
  function pick(from) {
    for (var k = 0; k < N; k++) { var idx = (from + k) % N; if (SOLD[ITEMS[idx].handle] !== false) return idx; }
    return from; // everything sold out (shouldn't happen) — show it honestly as "Sold out"
  }
  function slotEndsAt() { return (Math.floor(A.now() / 30000) + 1) * 30000; }

  function tick() {
    if (!ITEMS || !N) return;
    var idx = pick(baseSlot());
    if (idx !== shownSlot) { shownSlot = idx; render(idx); }
    updateTimers();
  }

  function render(idx) {
    var it = ITEMS[idx];
    cur = { it: it, idx: idx, sel: it.featured_variant_id, order: [it.featured_variant_id],
      vars: {} };
    cur.vars[it.featured_variant_id] = { name: it.featured_variant || 'Premium Vegan Leather', price: it.price, compare: it.compare_at, available: true };
    var url = '/products/' + it.handle;
    box.innerHTML =
      '<p class="afc-ld__kicker">⚡ Lightning deal · new one every 30 seconds</p>' +
      '<div class="afc-ld__card">' +
        '<a class="afc-ld__media" href="' + url + '" data-afc-quick="' + A.esc(it.handle) + '" data-hc-el="lightning-quick-view">' +
          '<img src="' + A.img(it.image, 900) + '" alt="' + A.esc(A.cleanTitle(it.title)) + '" width="900" height="1200">' +
          '<span class="afc-badge" data-ld-badge></span></a>' +
        '<div class="afc-ld__info">' +
          '<p class="afc-ld__timer">Deal ends in <b data-ld-left></b></p>' +
          '<div class="afc-ld__bar"><i data-ld-bar></i></div>' +
          '<h3 class="afc-ld__title"><a href="' + url + '" data-hc-el="lightning-title">' + A.esc(A.cleanTitle(it.title)) + '</a></h3>' +
          '<p class="afc-price"><span class="afc-price__now" data-ld-now></span> <s class="afc-price__was" data-ld-was></s></p>' +
          '<div class="afc-vars" role="radiogroup" aria-label="Leather" data-ld-vars hidden></div>' +
          '<button type="button" class="afc-btn afc-btn--big afc-btn--pulse" data-ld-add data-hc-el="lightning-claim">Claim</button>' +
          '<p class="afc-ld__note">Add it the moment you see it. Your price holds while your 60 minutes run — stock doesn&#39;t.</p>' +
        '</div>' +
      '</div>';
    paint();
    box.querySelector('[data-ld-add]').addEventListener('click', function () {
      var v = cur.vars[cur.sel];
      if (v && v.available) A.runAdd(this, cur.sel, A.img(cur.it.image, 300));
    });
    renderNext(idx + 1);
    var nd = ITEMS[(idx + 1) % N];
    if (nd) (new Image()).src = A.img(nd.image, 900);
    fetchLive(it, idx);
  }

  function fetchLive(it, idx) {
    fetch('/products/' + it.handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        var featured = p.variants.filter(function (v) { return v.id === it.featured_variant_id; })[0];
        SOLD[it.handle] = featured ? featured.available : false;
        if (cur && cur.idx === idx && SOLD[it.handle] === false) { shownSlot = null; tick(); return; } // skip now, don't wait for next slot
        if (!cur || cur.idx !== idx) return;
        var ordered = A.orderVariants(p.variants);
        cur.vars = {};
        ordered.forEach(function (v) { cur.vars[v.id] = { name: v.title, price: v.price / 100, compare: (v.compare_at_price || 0) / 100, available: v.available }; });
        cur.order = ordered.map(function (v) { return v.id; });
        if (!cur.vars[cur.sel] || !cur.vars[cur.sel].available) {
          var alt = cur.order.filter(function (id) { return cur.vars[id].available; })[0];
          if (alt) cur.sel = alt;
        }
        paint();
      })
      .catch(function () {});
  }

  function paint() {
    var v = cur.vars[cur.sel];
    var ids = cur.order;
    var labels = A.variantLabels(ids.map(function (id) { return cur.vars[id].name; }), true);
    box.querySelector('[data-ld-now]').textContent = A.money(v.price);
    box.querySelector('[data-ld-was]').textContent = v.compare > v.price ? A.money(v.compare) : '';
    var off = A.pct(v.price, v.compare) || cur.it.pct_off;
    var badge = box.querySelector('[data-ld-badge]');
    badge.textContent = off ? '−' + off + '%' : '';
    var btn = box.querySelector('[data-ld-add]');
    if (!btn.classList.contains('is-added')) {
      btn.disabled = !v.available;
      btn.textContent = !v.available ? 'Sold out' : 'Claim · ' + A.money(v.price);
    }
    var wrap = box.querySelector('[data-ld-vars]');
    wrap.hidden = ids.length < 2;
    if (ids.length < 2) return;
    wrap.innerHTML = ids.map(function (id, k) {
      var o = cur.vars[id];
      return '<button type="button" role="radio" class="afc-var' + (id === cur.sel ? ' is-on' : '') + '" aria-checked="' + (id === cur.sel) + '"' +
        (o.available ? '' : ' disabled') + ' data-v="' + id + '" data-hc-el="lightning-variant-picker">' + A.esc(labels[k]) + ' <b>' + A.money(o.price) + '</b></button>';
    }).join('');
    wrap.querySelectorAll('[data-v]').forEach(function (b) { b.addEventListener('click', function () { cur.sel = Number(b.dataset.v); paint(); }); });
  }

  // Up next ×4: clear photo + % OFF + live "in 19s", never name or price (DD ruling: unblurred, no fake scarcity)
  function renderNext(from) {
    var items = [];
    for (var k = 0; k < 4; k++) items.push(ITEMS[(from + k) % N]);
    nextRow.innerHTML = items.map(function (it, k) {
      return '<div class="afc-next__item"><div class="afc-next__img"><img src="' + A.img(it.image, 300) + '" alt="Upcoming deal" loading="lazy" width="300" height="400">' +
        '<span class="afc-next__off">−' + it.pct_off + '%</span></div><span data-next-k="' + k + '">in 30s</span></div>';
    }).join('');
  }

  function updateTimers() {
    var remain = slotEndsAt() - A.now();
    var left = box.querySelector('[data-ld-left]');
    if (left) left.textContent = A.mmss(remain);
    var bar = box.querySelector('[data-ld-bar]');
    if (bar) bar.style.width = Math.max(0, Math.min(100, remain / 30000 * 100)) + '%';
    nextRow.querySelectorAll('[data-next-k]').forEach(function (el) {
      el.textContent = 'in ' + (Math.ceil(remain / 1000) + Number(el.dataset.nextK) * 30) + 's';
    });
  }

  root.addEventListener('afc:phase', function (e) { if (e.detail.phase === 'live' && !started) { started = true; load(); } });
  if (A.phase && A.phase() === 'live' && !started) { started = true; load(); }
})();
